import React from "react";
import { ITEM_SORT_OPTIONS } from "../../data/StringConstants";
import DropdownMenu from "../Menus/PopupMenu/DropdownMenu";

//do not change these label/value combinations, they are tied to the DocumentSortColumn enum in DocumentRepository.cs
const options = [
   { value: "6", label: ITEM_SORT_OPTIONS.MODIFIED_DATE_DESC},
   { value: "5", label: ITEM_SORT_OPTIONS.MODIFIED_DATE_ASC},
   { value: "4", label: ITEM_SORT_OPTIONS.CREATION_DATE_DESC},
   { value: "3", label: ITEM_SORT_OPTIONS.CREATION_DATE_ASC},
   { value: "1", label: ITEM_SORT_OPTIONS.NAME_ASC},
   { value: "2", label: ITEM_SORT_OPTIONS.NAME_DESC}
];

export default function ItemSortSelect({value, onChange}) {
   const defaultOptionValue = options.find(x => x.label === ITEM_SORT_OPTIONS.MODIFIED_DATE_DESC).value;
   value = value ? value : defaultOptionValue;

   return (
      <DropdownMenu 
         options={options}
         onChange={onChange}
         value={value}
      />
   );
}
